// import React, { Component } from "react";
//
// import GoogleAnalytics from "react-ga";
//
// const withTracker = (WrappedComponent, options = {}) => {
// 	const trackPage = page => {
// 		if (localStorage.getItem("enableGoogleAnalytics") === "true") {
// 			GoogleAnalytics.initialize(localStorage.getItem("googleAnalyticsId"));
// 			GoogleAnalytics.set({
// 				page,
// 				...options
// 			});
// 			GoogleAnalytics.pageview(page);
// 		}
// 	};
//
// 	const HOC = class extends Component {
// 		componentDidMount() {
// 			const page = this.props.location.pathname;
// 			trackPage(page);
// 		}
//
// 		componentWillReceiveProps(nextProps) {
// 			const currentPage = this.props.location.pathname;
// 			const nextPage = nextProps.location.pathname;
//
// 			if (currentPage !== nextPage) {
// 				trackPage(nextPage);
// 			}
// 		}
//
// 		render() {
// 			return <WrappedComponent {...this.props} />;
// 		}
// 	};
//
// 	return HOC;
// };
//
// export default withTracker;

import React, {useEffect} from "react";
import {useLocation} from "react-router-dom";
import ReactGA from "react-ga4";

const withTracker = (WrappedElement, options = {}) => {
    const HOC = () => {
        const location = useLocation();
        useEffect(() => {
            if (localStorage.getItem("enableGoogleAnalytics") === "true") {
                const GA_MEASUREMENT_ID = localStorage.getItem("googleAnalyticsId");
                if (!ReactGA.isInitialized) {
                    ReactGA.initialize(GA_MEASUREMENT_ID);
                }
                ReactGA.send({hitType: "pageview", page: location.pathname, ...options,});
            }
        }, [location.pathname]);
        return WrappedElement; // must return a React element
    };
    return <HOC/>; // Return an element from the HOC
};

export default withTracker;